/**
 * @generated SignedSource<<398aeeb36c143102ed63ff6899049303>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "webhookService",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "homeOpenImplComponentsWebhookServiceQuery",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "homeOpenImplComponentsWebhookServiceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3d452af716a6f875e733812f6605645",
    "id": null,
    "metadata": {},
    "name": "homeOpenImplComponentsWebhookServiceQuery",
    "operationKind": "mutation",
    "text": "mutation homeOpenImplComponentsWebhookServiceQuery(\n  $request: WebhookServiceRequestInput\n) {\n  webhookService(request: $request) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "bebc8a677047f216878195ca4d0dfba8";

module.exports = node;
